/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { LiveContent } from './liveContent';

export interface LiveDetail {
  active?: boolean;
  collectionId?: string;
  content?: Array<LiveContent>;
  couponEnabled?: boolean;
  couponId?: number;
  couponName?: string;
  dateCreated?: Date;
  datePublished?: Date;
  dateUpdated?: Date;
  likes?: number;
  link?: string;
  liveId?: number;
  subtitle?: string;
  title?: string;
  views?: number;
}
